// Import Types
import type { EventNotification } from 'types';
// Import Configs
import { CRMRequestService, getCancelableRequest, postCancelableRequest } from './http.config';

const CampaignNotificationsHttpService = {
    getNotifications: () => {
        return getCancelableRequest<EventNotification[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/EventNotification/GetNotifications',
        });
    },
    saveNotifications: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => '/EventNotification/Save',
        });
    },
};

export default CampaignNotificationsHttpService;
